import { render, staticRenderFns } from "./FindPwd.vue?vue&type=template&id=fa0a480e&scoped=true"
import script from "./FindPwd.vue?vue&type=script&lang=js"
export * from "./FindPwd.vue?vue&type=script&lang=js"
import style0 from "./FindPwd.vue?vue&type=style&index=0&id=fa0a480e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0a480e",
  null
  
)

export default component.exports